<template>
  <transition name="toast-fade">
    <div v-if="toast" class="toast-wrap">
      <div class="toast">
        <span class="toast-icon">✓</span>
        {{ toast }}
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ToastNotification',
  computed: {
    ...mapState(['toast'])
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.toast-wrap {
  position: fixed;
  top: $nav-height + $spacing-base;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
}

.toast {
  @include flex-center;
  gap: $spacing-sm;
  background: rgba(#2D2D2D, 0.88);
  color: #fff;
  padding: $spacing-sm $spacing-lg;
  border-radius: $radius-full;
  font-size: $font-size-sm;
  font-weight: 500;
  backdrop-filter: blur(8px);
  box-shadow: $shadow-lg;
  white-space: nowrap;

  .toast-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    background: $color-success;
    border-radius: 50%;
    font-size: 11px;
    flex-shrink: 0;
  }
}

.toast-fade-enter-active, .toast-fade-leave-active {
  transition: all 0.3s ease;
}
.toast-fade-enter, .toast-fade-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-10px);
}
</style>
